module.exports = __webpack_public_path__ + "img/vdara9.327c93ac.jpg";